/* Reglas de texto, fase 1 (25-oct-2026): lo que necesita medir la página; el resto está en hai-texto.css.
   1. Lugares fijos por fila (regla 5): cada nombre de tarjeta ocupa lo mismo que el más largo de su fila (dos
      líneas como máximo, por el corte de hai-texto.css). Así la línea de datos y la descripción parten a la
      misma altura en todas, sin reservar una segunda línea en las filas donde todos los nombres caben en una.
   2. En escritorio, el título de un carrusel arranca donde arranca su primera tarjeta (en la home las cuatro
      fórmulas van centradas y empiezan en 184 px, y su título quedaba suelto en el borde de la página).
   Se recalcula al cambiar el ancho, al cambiar de pestaña y cuando llegan tarjetas tarde (recomendados,
   vistos recientemente, «Cargar más», filtros). Sin este script la página funciona igual: solo vuelve el desfase. */
(() => {
  function igualarFilas() {
    const nombres = [...document.querySelectorAll('.card__content .card__title-text')];
    nombres.forEach((n) => n.style.removeProperty('min-height'));
    const filas = new Map();
    for (const n of nombres) {
      const tarjeta = n.closest('.card-container') || n.closest('.card');
      const r = tarjeta && tarjeta.getBoundingClientRect();
      if (!r || !r.width) continue;
      const seccion = tarjeta.closest('[id^="shopify-section-"]');
      const clave = (seccion ? seccion.id : '') + '@' + Math.round(r.top + scrollY);
      if (!filas.has(clave)) filas.set(clave, []);
      filas.get(clave).push(n);
    }
    for (const fila of filas.values()) {
      if (fila.length < 2) continue;
      const alto = Math.max(...fila.map((n) => n.getBoundingClientRect().height));
      fila.forEach((n) => n.style.setProperty('min-height', alto + 'px'));
    }
  }

  function titulosConSuContenido() {
    const cabeceras = document.querySelectorAll('.slider__header');
    cabeceras.forEach((h) => h.style.removeProperty('padding-left'));
    if (innerWidth < 750) return;
    cabeceras.forEach((h) => {
      const raiz = h.closest('.shopify-section') || h.parentElement;
      const primera = raiz && raiz.querySelector('.slider__grid > *');
      if (!primera) return;
      const dx = primera.getBoundingClientRect().left - h.getBoundingClientRect().left;
      if (dx > 8) h.style.setProperty('padding-left', Math.round(dx) + 'px', 'important');
    });
  }

  let espera;
  const programar = () => {
    clearTimeout(espera);
    espera = setTimeout(() => { titulosConSuContenido(); igualarFilas(); }, 120);
  };
  const traeTarjetas = (n) => n.nodeType === 1 && (n.matches('.card__content, .card-container, .card') || !!n.querySelector('.card__content'));

  addEventListener('resize', programar);
  addEventListener('load', programar);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(programar);
  document.addEventListener('click', (e) => { if (e.target.closest('.component-tabs__tab')) setTimeout(programar, 350); });
  new MutationObserver((cambios) => {
    if (cambios.some((c) => [...c.addedNodes].some(traeTarjetas))) programar();
  }).observe(document.body, { childList: true, subtree: true });
  programar();
})();
